import { combineReducers } from "redux";
import { authReducer } from "./auth";
import { workerReducer } from "./worker";
import { workerdemanderReducer } from "./workerdemander";


export const rootReducer = combineReducers({authReducer,workerReducer,workerdemanderReducer})